import { brandApi } from "../../api";

const BrandService = {
    /**
     * Obtener todas las marcas.
     */
    getAll: async () => {
        try {
            const response = await brandApi.fetchAll();
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Obtener marcas activas para dropdown.
     */
    getDropdown: async () => {
        try {
            const response = await brandApi.fetchCustom("/dropdown");
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Buscar marca por nombre.
     */
    findByName: async (name: string) => {
        try {
            const response = await brandApi.fetchCustom(
                `/search?name=${name}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Crear marca.
     */
    save: async (data: object) => {
        try {
            const response = await brandApi.add(data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Actualizar marca.
     */
    update: async (
        id: number,
        name: string
    ) => {
        try {
            const response = await brandApi.modify(
                id,
                { name }
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Activar / desactivar marca.
     */
    deactivate: async (
        id: number
    ) => {
        try {
            const response =
                await brandApi.patchCustom(
                    `${id}/toggle-status`
                );

            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default BrandService;